import { useDispatch, useSelector } from "react-redux";
import { useCallback, useMemo } from "react";
import { authLogin, authLogout, setCorrupted as setCorruptedAction } from "../reducers/authSlice";

// --- 1. Strongly-typed (or JS-safe) Redux hooks ---
export const useAppDispatch = () => useDispatch();
export const useAppSelector = (selector) => useSelector(selector);

export const useAuthActions = () => {
  const dispatch = useAppDispatch();

  // --- Selectors ---
  const userInfo = useAppSelector((state) => state.auth.userInfo);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const userDocPath = useAppSelector((state) => state.auth.userDocPath);
  const isCorrupted = useAppSelector((state) => state.auth.isCorrupted);

  // --- Actions ---
  const login = useCallback(
    (data) => {
      if (data) {
        dispatch(
          authLogin({ userInfo: data.user, userDocPath: data.userDocPath })
        );
      }
    },
    [dispatch]
  );

  const logout = useCallback(() => {
    dispatch(authLogout());
  }, [dispatch]);

  const setCorrupted = useCallback(
    (value) => {
      dispatch(setCorruptedAction(value));
    },
    [dispatch]
  );

  // --- Return memoized API ---
  return useMemo(
    () => ({
      login,
      logout,
      userInfo,
      userDocPath,
      isAuthenticated,
      isCorrupted,
      setCorrupted,
    }),
    [login, logout, userInfo, isAuthenticated, userDocPath, isCorrupted, setCorrupted]
  );
};
